import { paths } from "helpers/paths";
import { ymEvent } from "helpers/system";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { productMetricsEventNames, sendEventLog } from "sources/eventLogs";
import Bolt from "./bolt.svg";
import RouteLine from "./route-line.svg";

const RegistrationSuccess = ({ close }: { close: () => void }) => {
    useEffect(() => {
        ymEvent("CreateBidAfterRegistrationModalViewed");
    }, []);

    const createBid = () => {
        ymEvent("CreateBidAfterRegistrationModalClicked");
        sendEventLog({
            name: productMetricsEventNames.TryOnOneTransportation,
            payload: { source: "registration_success_modal" },
        });

        close();

        window.dispatchEvent(new CustomEvent("onboardingFinished", {}));
    };

    return (
        <div className="registration-success">
            <div className="registration-success__close-x" onClick={close}>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M1 1L11 11M11 1L1 11"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </div>

            <div className="registration-success__content">
                <div className="registration-success__left">
                    <div className="registration-success__quick-start">
                        <Bolt />
                        Быстрый старт
                    </div>
                    <h1 className="registration-success__left-title">
                        <p className="pb-3">Попробуйте систему на первом рейсе</p>
                        <small>Обучайтесь в процессе - это проще, чем кажется</small>
                    </h1>
                    <RouteLine className="registration-success__left-route-line" />
                </div>

                <div className="registration-success__right">
                    <div className="registration-success__body">
                        <h2 className="registration-success__main-title">
                            Создайте первую заявку за 2 минуты и сразу увидите, как все работает
                        </h2>

                        <div className="registration-success__details">
                            <div className="registration-success__features">
                                <div className="registration-success__feature registration-success__feature--blue">
                                    <div className="registration-success__feature-icon registration-success__feature-icon--blue">
                                        <img src="/images/registration-success/map.svg" alt="map" />
                                    </div>
                                    <span>Маршрут построится автоматически с учетом всех ограничений</span>
                                </div>
                                <div className="registration-success__feature registration-success__feature--green">
                                    <div className="registration-success__feature-icon registration-success__feature-icon--green">
                                        <img src="/images/registration-success/phone.svg" alt="phone" />
                                    </div>
                                    <span>Водитель получит задание без звонков</span>
                                </div>
                                <div className="registration-success__feature registration-success__feature--red">
                                    <div className="registration-success__feature-icon registration-success__feature-icon--red">
                                        <img src="/images/registration-success/shield.svg" alt="shield" />
                                    </div>
                                    <span>Система сама посчитает пробег и сформирует отчеты</span>
                                </div>
                                <div className="registration-success__feature registration-success__feature--yellow">
                                    <div className="registration-success__feature-icon registration-success__feature-icon--orange">
                                        <img src="/images/registration-success/bell.svg" alt="bell" />
                                    </div>
                                    <span>Вы получите уведомление, если что-то пойдёт не так</span>
                                </div>
                            </div>

                            <div className="registration-success__stats">
                                <div className="d-flex gap-2 align-self-start align-items-center pb-2">
                                    <div className="registration-success__stats-circle">90%</div>
                                    <div className="registration-success__stats-text">
                                        пользователей начинают работу именно с первой заявки
                                    </div>
                                </div>
                                <div className="registration-success__stats-subtext">
                                    Заявку можно удалить в любой момент
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="registration-success__footer">
                        <Link to={paths.bidNew} className="registration-success__button" onClick={createBid}>
                            Попробовать на 1 перевозке
                            <img src="/images/registration-success/arrow-right.svg" alt="arrow-right" />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RegistrationSuccess;
